import { ShieldBan } from "lucide-react";
import { useTranslations } from "use-intl";

import { authClient } from "@platform/auth/client";

// Shown in place of the page outlet when the active membership is suspended.
// The tenant switcher and log-out stay in the chrome as escape hatches.
export function SuspendedNotice() {
	const { data: active } = authClient.useActiveOrganization();
	const tenantName = active?.name;
	const t = useTranslations("common.errors");

	return (
		<div className="flex h-full items-center justify-center">
			<div className="flex max-w-md flex-col items-center gap-3 text-center">
				<div className="bg-destructive/10 flex size-12 items-center justify-center rounded-full">
					<ShieldBan className="text-destructive size-6" />
				</div>
				<h1 className="text-lg font-semibold">{t("suspended.heading")}</h1>
				<p className="text-muted-foreground text-sm">
					{t("suspended.message", { tenantName: tenantName as string })}
				</p>
			</div>
		</div>
	);
}
